<template>
    <v-list-group
        :value="true"
        prepend-icon="mdi-account-circle"
        color="primary"
        v-model="item.model"
    >
        <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint"> {{ item.icon }} </v-icon>
        </template>

        <template v-slot:activator >
            <v-list-item-content>
                <v-badge v-if="item.badge" content="New" color="secondary"></v-badge>
                <v-list-item-title> {{ item.title }} </v-list-item-title>
            </v-list-item-content>
        </template>

        <v-list-item
            v-for="(child, i) in itemChild"
            :key="(i + 'itm')"
            :to="child.link"
            link
            class="pl-12"
            @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon size="">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>
                  {{ child.title }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-group
            v-for="(ichild, i) in itemGroup"
            :key="(i + 'grp')"
            :value="true"
            no-action
            sub-group
        >
            <template v-slot:activator>
                <v-list-item-content>
                    <v-list-item-title>{{ ichild.title }}</v-list-item-title>
                </v-list-item-content>
            </template>

            <v-list-item
                v-for="(child, i) in ichild.children"
                :key="(child.title + i)"
                :to="child.link"
                link
                class="pl-12"
                @click="child.action ? child.action() : null"
            >
                <v-list-item-action class="mr-2" v-if="child.icon">
                <v-icon size="">{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                    {{ child.title }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-group>
    </v-list-group>
</template>
  
<script>
    export default {
        name: 'SidebarListGroup',
        props: {
            item: Object,
        },
        data() {
            return {
            }
        },
        computed: {
            itemChild(){
                return this.item.children.filter(ch => ! ch.children);
            },
            itemGroup(){
                return this.item.children.filter(ch => ch.children);
            },
        }
    };
</script>